import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Button from "module-common/Button";

export default class TextArea extends Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    onSave: PropTypes.func,
    isLoading: PropTypes.bool,
    editable: PropTypes.bool,
    isMutationDone: PropTypes.bool,
    initialValue: PropTypes.string
  };
  static defaultProps = {
    value: "",
    initialValue: "",
    onChange: null,
    onSave: null,
    isLoading: false,
    isMutationDone: false
  };

  isValueChanged() {
    let isChanged = this.props.value !== this.props.initialValue;
    return isChanged;
  }

  render() {
    const { value, onSave, isLoading, editable, isMutationDone } = this.props;
    return (
      <Wrapper>
        <Input
          placeholder="Write your notes here"
          rows={6}
          value={value}
          onChange={this.onChange}
          disabled={!editable}
        />
        {editable && (
          <WrapperButton>
            <Button
              onClick={onSave}
              rounded
              size="medium"
              color="blue"
              forcedColor={isMutationDone ? "green" : null}
              loading={isLoading}
              disabled={isLoading || !this.isValueChanged()}
            >
              {isMutationDone ? "Saved" : "Save"}
            </Button>
          </WrapperButton>
        )}
      </Wrapper>
    );
  }

  onChange = event => {
    const onChange = this.props.onChange;
    if (onChange) onChange(event.target.value);
  };
}

const Wrapper = styled.div`
  position: relative;
  align-self: flex-start;
`;
const Input = styled.textarea`
  width: 100%;
  padding: 8px;
  resize: none;
  border: none;
  background-color: ${props => props.theme.textAreaBackground};
  border-radius: 3px;
  border: 1px solid ${props => props.theme.panelBorder};
  &:focus {
    outline: none;
    background-color: #fff;
  }
`;
const WrapperButton = styled.div`
  position: relative;
  float: right;
`;



// WEBPACK FOOTER //
// ./src/module-case-management/info-panel/TextArea.js